import React from 'react';
import { Button } from '@mui/material';
import ReactExport from 'react-export-excel';
import { Icon } from '@iconify/react';
import { terminal_id_recargas, terminal_id_servicios } from '../../../../config';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;

function ReportePagosServiciosRecargas({ dataList = [] }) {
  console.log(terminal_id_recargas, terminal_id_servicios);
  return (
    <ExcelFile
      element={
        <Button variant="contained" startIcon={<Icon icon="eva:file-text-fill" />}>
          Reporte conciliacion
        </Button>
      }
    >
      <ExcelSheet data={dataList} name="Reporte">
        <ExcelColumn label="Date_Time" value="TransactionDateTime" />
        {/* <ExcelColumn label="Terminal_Id" value={(col) => (col.type === 'recarga' ? '8627128' : '4847434')} /> */}
        <ExcelColumn
          label="Terminal_Id"
          value={(col) => (col.type === 'recarga' ? terminal_id_recargas : terminal_id_servicios)}
        />
        <ExcelColumn label="ResponseTransaction_Id" value="InvoiceNo" />
        <ExcelColumn label="Product_Id" value="productId" />
        <ExcelColumn label="Amount_Id" value={(col) => (col.providerAmount ? col.providerAmount : col.totalAmount)} />
        <ExcelColumn label="Account ID" value="accountId" />
        <ExcelColumn label="ResponseCode" value="ResponseCode" />
        {/* <ExcelColumn label="Invoice_Id" value={(col) => (col.is_married ? 'Married' : 'Single')} /> */}
      </ExcelSheet>
    </ExcelFile>
  );
}

export default ReportePagosServiciosRecargas;
